import { render } from "./WorkflowDialog.vue?vue&type=template&id=5367a7ab&scoped=true"
import script from "./WorkflowDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowDialog.vue?vue&type=script&lang=js"

import "./WorkflowDialog.vue?vue&type=style&index=0&id=5367a7ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5367a7ab"]])

export default __exports__